import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/buttons/Button";
import Content from "../../../components/Content";
import InputField from "../../../components/Inputs/InputField";
import {
  DeleteFacility,
  GetFacilityById,
  UpdateFacility,
} from "../../../hooks/useFacilityData";

export const FacilityEditView = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [edited, setEdited] = useState(false);
  const [facilityData, setFacilityData] = useState([]);
  const param = useParams();
  const facilityId = param.id;

  const { data: facility } = GetFacilityById(facilityId);

  useEffect(() => {
    if (facility?.data) {
      setFacilityData(facility.data); // Set the facilityData with the API response
    }
  }, [facility]);

  const deleteFacilityMutation = DeleteFacility({
    onSuccess: () => {
      enqueueSnackbar("Anläggning raderad.", { variant: "success" });
      navigate(`/admin/overview/${facility?.data.organisation_id}`);
    },
    onError: (error) => {
      console.log("🚀 ~ FacilityEditView ~ error:", error);
      enqueueSnackbar("Kunde inte radera anläggning.", { variant: "error" });
    },
  });

  const handleDelete = () => {
    deleteFacilityMutation.mutate(facilityId);
  };

  const updateFacilityMutation = UpdateFacility({
    onSuccess: () => {
      enqueueSnackbar("Anläggning uppdaterad.", { variant: "success" });
    },
    onError: (error) => {
      enqueueSnackbar("Kunde inte uppdatera anläggning.", { variant: "error" });
    },
  });

  const handleUpdate = () => {
    const updatedFacilityData = {
      ...facilityData,
    };

    // Make sure to spread the state correctly
    updateFacilityMutation.mutate({ facilityId, updatedFacilityData });
    setEdited(false); // Reset the edited state after saving
  };

  return (
    <Content title={`${facilityData?.facility_name || "Anläggning"}`}>
      <div className="container" style={{ width: "50%", gap: "1em" }}>
        <div style={{ display: "grid", gap: "0.5em" }}>
          Anläggning
          <div className="form-grid-auto">
            <InputField
              // required
              label={"Namn på anläggning"}
              type={"text"}
              value={facilityData.facility_name} // Bind value to facilityData
              onChange={(e) => {
                setFacilityData({
                  ...facilityData,
                  facility_name: e.target.value, // Update facility_name in the state
                });
                setEdited(true); // Mark as edited
              }}
            />
          </div>
        </div>

        <div className="rightAlign-button-container">
          <Button className={"danger"} color="error" onClick={handleDelete}>
            Ta bort
          </Button>
          <Button
            className={edited ? "button-pulse" : undefined}
            disabled={!edited}
            color="success"
            onClick={handleUpdate}
          >
            Spara
          </Button>
        </div>
      </div>
    </Content>
  );
};
